import { render, staticRenderFns } from "./shipping-message-info.vue?vue&type=template&id=36dd94e6&"
import script from "./shipping-message-info.vue?vue&type=script&lang=js&"
export * from "./shipping-message-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports